/**
 * @generated SignedSource<<221cef06b11d9df37e7787bfb0eadf39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DateSelectorControlFragment_facility$data = {
  readonly club: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
  } | null | undefined;
  readonly durations: ReadonlyArray<number | null | undefined> | null | undefined;
  readonly id: string;
  readonly publicBookingWindowDays: number | null | undefined;
  readonly startEndTime: {
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "DateSelectorControlFragment_facility";
};
export type DateSelectorControlFragment_facility$key = {
  readonly " $data"?: DateSelectorControlFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"DateSelectorControlFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DateSelectorControlFragment_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityStartEndTime",
      "kind": "LinkedField",
      "name": "startEndTime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicBookingWindowDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetClubStartOfWeekNumberPatron_club"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "4e029905bd6e0bcad708c39c46894469";

export default node;
